import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useCallback, useContext } from 'react';
import get from 'lodash/get';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { useTranslation } from 'react-i18next';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { BiData, BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ArrowDown from '@wix/da-ds/pkg/Icons/ArrowDown';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { getDeviationResourceType } from '../../../../DeviationViews/_helpers';
import { NotificationType } from '../../../../Notifications';
import { getDeviationNotificationQueue } from '../../../../DeviationPage/redux/helpers';
import { useRestrictToLoggedIn } from '../../../../utils/hooks/useRestrictToLoggedIn';
import FavingIcon from '../../../../FaveButton/FavingIcon';
import ActionBarItemWrapper from '../../../_partials/items/ActionBarItemWrapper';
import ActionBarToggleButton from '../../../_partials/items/ActionBarToggleButton';
import { yieldToMain } from '@wix/da-hooks/pkg/yieldToMain';
import s from './FavouriteButton.scss';
function getDeviationBiData(deviation) {
    return {
        creatorid: get(deviation, 'author.useridUuid'),
        typeid: getDeviationResourceType(deviation),
        itemid: deviation.deviationId
    };
}
const FavouriteButton = ({ deviation, onChangeFave, onArrowClick })=>{
    const isMobile = useContext(MobileContext);
    const { t } = useTranslation();
    const { restrictToLoggedIn } = useRestrictToLoggedIn();
    const isFavourited = !!deviation.isFavourited;
    const queueName = isMobile ? 'default' : getDeviationNotificationQueue(deviation);
    const onClick = ()=>{
        return yieldToMain(()=>onChangeFave(deviation, !isFavourited, queueName));
    };
    const FavingIconWithState = useCallback((iconProps)=>/*#__PURE__*/ React.createElement(FavingIcon, _object_spread_props(_object_spread({}, iconProps), {
            isFavourited: isFavourited,
            deviationId: deviation.deviationId
        })), [
        isFavourited,
        deviation.deviationId
    ]);
    return /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: getDeviationBiData(deviation)
    }, /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
        notificationTypes: [
            NotificationType.Collect,
            NotificationType.CollectUndo,
            NotificationType.Fave,
            NotificationType.FaveUndo
        ],
        popoverWrapperClassName: s['button-with-dropdown'],
        renderReference: ({ ref })=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ActionBarToggleButton, {
                onClick: onClick,
                // Since mobile doesn't have a label, we'll duplicate the desktop one to cover it.
                "aria-label": t(isFavourited ? 'actionbar.inFavourites' : 'actionbar.addToFavourites'),
                label: isMobile ? undefined : t(isFavourited ? 'actionbar.inFavourites' : 'actionbar.addToFavourites'),
                biData: BiData({
                    evid: isFavourited ? 109 : 102,
                    creatorid: BiContextProvidedValue,
                    typeid: BiContextProvidedValue,
                    itemid: BiContextProvidedValue
                }),
                icon: FavingIconWithState,
                iconRef: ref
            }), /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
                className: s['arrow-down-wrapper'],
                onClick: restrictToLoggedIn(ReferralType.FAVOURITE, onArrowClick),
                biData: BiData({
                    evid: 333,
                    sectionname: 'arrowButton'
                }),
                "aria-label": t('actionbar.a11y.favouritePopupArrow')
            }, /*#__PURE__*/ React.createElement(ArrowDown, {
                size: IconSize.SMALLER
            })))
    }));
};
FavouriteButton.displayName = 'FavouriteButton';
export default FavouriteButton;

//# sourceMappingURL=FavouriteButton.js.map